// app.config.ts
export default defineAppConfig({
  ui: {
    // ✅ Mapeamento de cores semânticas (API correta do v4)
    colors: {
      primary: 'primary',
      neutral: 'customGray',
    },

    // ✅ Estilo global de componentes via slots
    button: {
      slots: {
        base: 'normal-case font-sans',
      },
    },

    card: {
      slots: {
        root: 'px-4 rounded-xl',
        header: 'border-none',
      },
    },

    select: {
      slots: {
        trailingIcon: 'ph:caret-down-bold',
      },
    },

    // ⚠️ Verifique se selectMenu ainda existe na versão exata do @nuxt/ui que você usa
    selectMenu: {
      slots: {
        trailingIcon: 'ph:check-bold',
      },
    },
  },
})